"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var is_future_date_1 = require("./is-future-date");

var constants_1 = require("./constants");

function isLessThanOneHourAgo(date, now) {
  if (now === void 0) {
    now = new Date();
  }

  return !is_future_date_1.isFutureDate(date, now) && now.getTime() - date.getTime() < constants_1.TimeUnit.Hour;
}

exports.isLessThanOneHourAgo = isLessThanOneHourAgo;